<template>
  <span>
    <v-dialog v-model="showAddSchedule" width="800px" persistent>
      <template v-slot:activator="{ on }">
        <v-btn class="mr-2" v-on="on" color="info" dark @click.native="initSchedule">
          {{ label.schedule }}
          <v-icon dark right>mdi-clock</v-icon>
        </v-btn>
      </template>
      <form data-vv-scope="batchJobForm">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-icon>mdi-clock</v-icon>
            <v-toolbar-title>Schedule Job</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <message :messages="messages"></message>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex md6 xs12>
                  <v-autocomplete
                    :items="jobs"
                    v-model="batchForm.jobName"
                    :label="label.jobName"
                    item-text="label"
                    item-value="value"
                    data-vv-name="batchForm.jobName"
                    :data-vv-as="label.jobName"
                    :error-messages="errors.collect('batchForm.jobName')"
                    v-validate="'required'"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex md6 xs12 v-if="showJobMode">
                  <v-autocomplete
                    :items="jobModes"
                    v-model="batchForm.jobMode"
                    :label="label.jobMode"
                    item-text="label"
                    item-value="value"
                    data-vv-name="batchForm.jobMode"
                    :data-vv-as="label.jobMode"
                    :error-messages="errors.collect('batchForm.jobMode')"
                    v-validate="'required'"
                    clearable
                  ></v-autocomplete>
                </v-flex>
                <v-flex md6 xs12 v-if="batchForm.jobMode === 'ONCE'">
                  <cal-picker
                    v-model="batchForm.jobSchedule"
                    :label="label.jobSchedule"
                    :error-messages="errors.collect('batchForm.jobSchedule')"
                    :data-vv-as="label.jobSchedule"
                    v-validate="'required'"
                    data-vv-name="batchForm.jobSchedule"
                  ></cal-picker>
                </v-flex>
                <v-flex md12 xs12>
                  <v-dialog ref="dialog" v-model="timeModal" :return-value.sync="batchForm.jobScheduleTime" persistent width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="batchForm.jobScheduleTime"
                        v-validate="'required'"
                        :data-vv-as="label.jobScheduleTime"
                        data-vv-name="batchForm.jobScheduleTime"
                        :error-messages="errors.collect('batchForm.jobScheduleTime')"
                        :label="label.jobScheduleTime"
                        readonly
                        v-on="on"
                      >
                      </v-text-field>
                    </template>
                    <v-time-picker v-if="timeModal" v-model="batchForm.jobScheduleTime">
                      <v-spacer></v-spacer>
                      <v-btn color="red darken-1" text @click="timeModal = false">Cancel</v-btn>
                      <v-btn color="primary" text @click="$refs.dialog.save(batchForm.jobScheduleTime)">OK</v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showAddSchedule = false">Cancel</v-btn>
            <v-btn color="primary" @click="submitSchedule">Schedule</v-btn>
          </v-card-actions>
        </v-card>
      </form>
    </v-dialog>
  </span>
</template>
<script>
import MessageMixin from '@/mixins/message'
import { batchScheduleMixin } from '@/mixins/common/batchScheduleMixin'
export default {
  data() {
    return {
      label: {
        schedule: 'Schedule',
        jobName: 'Job Name',
        jobCron: 'Job Cron Expression',
        jobSchedule: 'Schedule Date',
        jobMode: 'Frequency',
        jobScheduleTime: 'Schedule Time'
      },
      jobModes: [{ label: 'Run Once', value: 'ONCE' }],
      jobWarningMessage: '',
      days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      selectedDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      showAddSchedule: false,
      timeModal: false
    }
  },
  methods: {
    submitSchedule() {
      this.resetMessages()
      this.$validator.validateAll('batchJobForm').then((result) => {
        if (result) {
          this.processRequest(this.parentForm)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    initSchedule() {
      this.$parent.$parent.$validator.validateAll().then((result) => {
        if (result) {
          this.showAddSchedule = true
        } else {
          this.promptFieldCheck()
        }
      })
    }
  },
  computed: {
    jobs() {
      if (this.jobNames != null && this.jobNames.length > 0) {
        return this.jobNames
      } else {
        return this.defaultJobNames
      }
    }
  },
  watch: {
    jobNames: function (value) {
      if (value && value.key) {
        this.batchForm = value.key
      }
    }
  },
  props: {
    parentForm: {
      type: Object,
      default: null
    },
    jobNames: {
      type: Array,
      default: null
    },
    showJobMode: {
      type: Boolean,
      default: true
    }
  },
  mixins: [MessageMixin, batchScheduleMixin]
}
</script>
